
jQuery(function ($) { // この中であればWordpressでも「$」が使用可能になる

  var topBtn = $('.pagetop');
  topBtn.hide();

  // ボタンの表示設定
  $(window).scroll(function () {
    if ($(this).scrollTop() > 70) {
      // 指定px以上のスクロールでボタンを表示
      topBtn.fadeIn();
    } else {
      // 画面が指定pxより上ならボタンを非表示
      topBtn.fadeOut();
    }
  });

  // ボタンをクリックしたらスクロールして上に戻る
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });

  //ドロワーメニュー　あとで質問する！！
  // $("#MenuButton").click(function () {
  //   // $(".l-drawer-menu").toggleClass("is-show");
  //   // $(".p-drawer-menu").toggleClass("is-show");
  //   $(".js-drawer-open").toggleClass("open");
  //   $(".drawer-menu").toggleClass("open");
  //   $("html").toggleClass("is-fixed");

  // });
  $('.js-hamburger').on('click', function () {
    if ($(this).hasClass('open')) {
      $('.js-drawer-menu').fadeOut();
      $(this).removeClass('open');
    } else {
      $('.js-drawer-menu').fadeIn();
      $(this).addClass('open');
    }
  });

  // モーダル
  $('.js-modal-btn').on('click', function () {
    if ($(this).next('.c-modal').hasClass('c-modal--open')) {
      // $(this).next('.c-modal').fadeOut();
      $(this).next().removeClass('c-modal--open');
    } else {
      // $(this).next('.c-modal').fadeIn();
      $(this).next().addClass('c-modal--open');
    }
  });
  $('.js-modal-close').on('click', function () {
    $('.c-modal').removeClass('c-modal--open');
  });

  // 研修動画絞り込み＿変色
  $('.p-modal-select__item').on('click', function() {
    // if($(this).hasClass('.p-modal-select__item--selected')) {
    //   $(this).removeClass('p-modal-select__item--selected');
    // } else {
    //   $(this).addClass('p-modal-select__item--selected');
    // }
    $(this).toggleClass('p-modal-select__item--selected');
    $(this).toggleClass('box-shadow-15');
    if ($(this).attr('data-select-tag') == "") {
        var tagName = $(this).text();
        $(this).attr('data-select-tag', tagName);
    } else {
        $(this).attr('data-select-tag', "");
    }
  })

  // 研修動画絞り込みボタンクリック
  $('#form-study-search').on('submit', function() {
    var tags = $(this).find('.p-modal-select__item');
    tags.each(function(index, element) {
        if ($(element).attr('data-select-tag') != "") {
            var selectTag = $(element).attr('data-select-tag');
            $('<input>',{
                type: 'hidden',
                name: 'tags[]',
                value: selectTag
              }).appendTo($(this));
        }
    })
  })

  // 初回ログインボタン＿変色
  $('.p-modal-login__btn').on('click', function() {
    // if($(this).hasClass('.p-modal-select__item--selected')) {
    //   $(this).removeClass('p-modal-select__item--selected');
    // } else {
    //   $(this).addClass('p-modal-select__item--selected');
    // }
    $(this).toggleClass('p-modal-login__selected');
    $(this).toggleClass('box-shadow-15');
  })



  // スムーススクロール (絶対パスのリンク先が現在のページであった場合でも作動)

  $(document).on('click', 'a[href*="#"]', function () {
    let time = 400;
    let header = $('header').innerHeight();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({ scrollTop: targetY }, time, 'swing');
    return false;
  });

});

//スクロールでふわっと表示
let fadeInTarget = document.querySelectorAll('.js-fade-in');
window.addEventListener('scroll', () => {
	for (let i = 0; i < fadeInTarget.length; i++) {
		const rect = fadeInTarget[i].getBoundingClientRect().top;
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const offset = rect + scroll;
		const windowHeight = window.innerHeight; // 現在のブラウザの高さ
		if (scroll > offset - windowHeight + 150) {
			fadeInTarget[i].classList.add('js-scroll-in');
		}
	}
});
